import { render, staticRenderFns } from "./RsaSchedaValutazioneAllegatoAEditComponent.vue?vue&type=template&id=6c50f735"
import script from "./RsaSchedaValutazioneAllegatoAEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaValutazioneAllegatoAEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports